import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list':
    'Quickly build standard, pages based on `block` development',
  'app.theme.selector': 'Theme Selector',
  'app.theme.settings': 'Theme Settings',
  'app.theme.settings.description': 'Choose your page theme and experience different color styles~',
  'app.theme.light': 'Light Theme',
  'app.theme.light.description': 'Fresh white background, dark text with classic blue buttons. A bright theme suitable for daytime use.',
  'app.theme.dark': 'Dark Theme',
  'app.theme.dark.description': 'Deep black background, clear white text with classic blue buttons. A dark theme suitable for nighttime use.',
  'app.theme.darkOrange': 'Dark Orange Theme',
  'app.theme.darkOrange.description': 'Deep black background, clear white text with vibrant orange buttons. A personalized dark theme choice.',
  'app.theme.minimal': 'Minimal Theme',
  'app.theme.minimal.description': 'Clean white background, dark text with pure black buttons. A theme choice for minimalist aesthetics.',
  'app.theme.switch.success': 'Theme switched successfully! Recommend refreshing the page for the best experience.',
  'app.theme.reset': 'Follow Browser Default',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
};
